module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAMBAMAAADWlCNiAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMARHfuuzOqmWYRzCLdiFXMgq31AAAA4klEQVQY02OAAZ4GBgZGAwZDBgaODZzVDEDOfyD4wMDAvgDI/sDwkYFhludXd5YCIAcEmUDSAowf7P9/ZuA0NHq/XwEmAdTDL5D/X+GjPNCUNI74AIhREAmgjhW/5R3sP/RPuMOAatTvTx/kvzJ+mKxgBLOczYGBgW0D46ezDvpGQGVG1gwMTA4gHVwKDCAX/n2joOLL+IHTHshluwCS2P8ALPFBeYIKA+O30vMFDAzxDSCJYgawxNcfDMsYOH4pJ5kEMKgwsBr+L1gBlmA1K1hvysBU8okh5CMDFsA6gYFBAABW2GCP2RsSWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/policy/policy-cn.png
// module id = M0fL
// module chunks = 1